import React from 'react';
import { Checkbox, FormControlLabel, Typography, Link, Box, FormHelperText } from '@mui/material';
import { config } from '~/config';
import { BOOKING_CONTEXT } from '~/literals';

interface BookingTermsAndConditionsProps {
  onAccept: (accepted: boolean) => void;
  onFareRulesClick: () => void;
  accepted: boolean;
  errorMessages: string[];
  bookingContext?: string;
}

const BookingTermsAndConditions = ({ onAccept, onFareRulesClick, accepted, errorMessages, bookingContext }: BookingTermsAndConditionsProps) => {
  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onAccept(event.target.checked);
  };

  const handleFareRulesClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    onFareRulesClick();
  };

  return (
    <Box display="flex" flexDirection="column" alignItems="flex-start" padding="16px" margin={0}>
      <FormControlLabel
        control={
          <Checkbox
            checked={accepted}
            onChange={handleCheckboxChange}
            color="primary"
            sx={{ alignSelf: 'flex-start' }}
          />
        }
        label={
          <Typography variant="body2" color="textSecondary">
            By proceeding,{' '}
            {bookingContext === BOOKING_CONTEXT.FLIGHT_ITINERARY && (
              <><b>I acknowledge that I am booking a non-ticketed flight itinerary and </b><br /></>
            )}
            I agree to and accept the{' '}
            {bookingContext !== BOOKING_CONTEXT.FLIGHT_ITINERARY && (
              <>
                <Link href="#" onClick={handleFareRulesClick}>
                  Fare Rules
                </Link>,{' '}
              </>
            )}
            <Link href={`${config.app.helpCenterLink}/terms-of-service`} target="_blank" rel="noopener">
              Tripenger Terms of Service
            </Link>, and{' '}
            <Link href={`${config.app.helpCenterLink}/privacy-policy`} target="_blank" rel="noopener">
              Privacy Policy
            </Link>.
          </Typography>
        }
      />
      {errorMessages.length > 0 && (
        <FormHelperText error>{errorMessages.map(err => <p key={err}>{err}</p>)}</FormHelperText>
      )}
    </Box>
  );
};

export default BookingTermsAndConditions;
